import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FormItemProps } from "apis";
import { FieldItemProps } from "apis/field";

export interface FormBuilderState {
    loading: boolean;
    saved?: boolean;
    form?: FormItemProps;
    fields: FieldItemProps[];
    _selectField?: FieldItemProps;
    _tab?: 1 | 2 | 3;
    _showPropertiesTab?: boolean;
}

const initialState: FormBuilderState = {
    loading: false,
    fields: [],
    _tab: 1
};

interface UpdateFields {
    fields: FieldItemProps[]
}
export const formBuilderSlice = createSlice({
    name: "form-builder",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        init: (state, action: PayloadAction<FormBuilderState>) => {
            if (state.form?.id && action.payload.form?.id === state.form?.id) {
                state.saved = true;
            }
            state.loading = false;
            state.form = action.payload.form;
            state.fields = action.payload.fields;
            state._selectField = undefined;
        },
        destroy: (state) => {
            state.loading = false;
            state.form = undefined;
            state.fields = [];
            state.saved = undefined;
            state._selectField = undefined;
            state._showPropertiesTab = undefined;
            state._tab = undefined;
        },
        selectField: (state, action: PayloadAction<FieldItemProps>) => {
            if (Boolean(state._selectField) && state._selectField?.id === action.payload.id) {
                state._selectField = undefined;
            }
            else {
                state._selectField = action.payload;
                state._tab = 3;
                state._showPropertiesTab = true;
            }
        },
        onChangeTab: (state, action: PayloadAction<1 | 2 | 3>) => {
            state._tab = action.payload;
            if (state._tab !== 3 && state._selectField?.id === -1) {
                state._selectField = undefined;
            }
        },
        onShowPropertiesTab: (state, action: PayloadAction<boolean>) => {
            state._showPropertiesTab = action.payload;
        },
        updateFields: (state, action: PayloadAction<UpdateFields>) => {
            state.fields = action.payload.fields;
            state.saved = false;
        },
    },
});

export const { loading, init, destroy, selectField, onChangeTab, onShowPropertiesTab, updateFields } = formBuilderSlice.actions;
export default formBuilderSlice.reducer;
